export const ANDROID_IDENTIFIER = 'android';
export const IOS_IDENTIFIER = 'ios';
